
import {Component, Mixins, Prop} from "vue-property-decorator";
import EnumPicker from "@/components/pickers/EnumPicker.vue";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import {DavaSonucu, DavaSonucuLabel} from "@/enum/DavaSonucu";

@Component({
  components: {EnumPicker}
})

export default class DavaSonucuPicker extends Mixins(SimpleInputMixin) {
  davaSonucu = DavaSonucu;
  davaSonucuLabel = DavaSonucuLabel;

}

